<template>
  <div class="content">
    <div class="reset-wrapper">
      <div class="reset">
        
        <h3>Password Reset</h3>
        <h4 v-if='isLoggedIn'>DISABLED. PLEASE LOGOUT FIRST</h4>
        <form @submit.prevent="handleResetPassword" class="form" ref="formContainer">

          <div v-if="!form.email" class="b-form-group form-group" role="group">
            <label class="col-form-label pt-0">Email: </label>
            <input :disabled='isLoggedIn' id="email" type="text"
                   v-model="form.email"
                   class="form-control form__input"
                   required>
          </div>

          <div v-if="!form.token" class="b-form-group form-group" role="group">
            <label class="col-form-label pt-0">Token: </label>
            <input :disabled='isLoggedIn' id="token" type="text"
                   v-model="form.token"
                   class="form-control form__input"
                   required>
          </div>

          <div class="b-form-group form-group" role="group">
            <label class="col-form-label pt-0">New Password: </label>
            <input :disabled='isLoggedIn' id="password"
                   v-model="form.password"
                   class="form-control form__input"
                   required
                   type="password"
                   placeholder="Enter new password"
                   @change="validatePassword">
            <form-error :errors="formErrors.password"/>
          </div>

          <div class="b-form-group form-group" role="group" id="exampleInputGroup2">
            <label class="col-form-label pt-0">Confirm Password: </label>
            <input :disabled='isLoggedIn' id="password2"
                   v-model="form.password2"
                   class="form-control form__input"
                   required
                   type="password"
                   placeholder="Confirm password"
                   @change="confirmPassword">
            <form-error :errors="formErrors.password2"/>
          </div>

          <div class="button-group">
            <button type="submit" class="col-md-12 col-12 btn btn--reset">Reset Password</button>
            <router-link to="/login" class="form__link">Back to login</router-link>
            <div v-bind:class="messageClass" v-html="statusMessage"></div>
          </div>
        </form>
      </div>

    </div>
  </div>

</template>

<script>
import {
  resetPassword
} from '@/api/userApi';
import {
  PASSWORD_RESET_SUCCESS_MESSAGE,
  TOKEN_MISMATCH_MESSAGE,
  TOKEN_EXIPRED_MESSAGE,
  NO_SUCH_USER_MESSAGE,
  PASSWORD_IN_USE_MESSAGE,
  WRONG_PASSWORD_FORMAT_MESSAGE 
} from '@/api/ajaxActionResponse';
import FormError from './register/FormError';
import VALIDATION_ERRORS from '@/data/validationErrors';
import {
  LoginNavigation
} from '@/store/modules/fsm/messages';
import router from '@/router/index';

export default {
  name: 'reset-password-page',
  data() {
    return {
      form: {
        email: '',
        token: '',
        password: '',
        password2: ''
      },
      formErrors: {},
      statusMessage: ''
    }
  },
  components: {
    'form-error': FormError,
  },
  computed: {
    messageClass: function() {
      return this.statusMessage.length === 0 ? 'd-none' : 'alert alert-warning';
    },
    isLoggedIn: function() {
        let isLoggedIn = store.getters['login/isLoggedIn'];
        return isLoggedIn;
    }
  },
  beforeCreate() {
    window.sessionStorage.triedToResetPassword = Date.now();
    if(this.isLoggedIn) {
      alert('Please logout to reset password');
      router.push({name:LoginNavigation});
    }
    let isInit = this.$gotInitialMessage();
    if(!isInit)
    {
      let href = location.href + '';
      setTimeout(() => location.assign(href),5000);
    }
  },
  created() {

    if (this.$route.query['email'] && this.$route.query['token']) {
      this.form.email = this.$route.query['email'];
      this.form.token =this.$route.query['token'];
    }
    // initialize errors
    for (let key in this.form) {
      this.$set(this.formErrors, key, []);
    }
  },
  methods: {
    handleResetPassword() {
      if(this.isLoggedIn)
        return;
      resetPassword(this.form)
      .then((data) => {
          this.statusMessage = '';
          alert('Success! You can now log in using your new password.');
          router.push({name:LoginNavigation});
      })
      .catch((err) => {
        this.statusMessage = err;
      });

    },
    validatePassword() {

      const strongRegex = new RegExp(`^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[~!@#\$%\^&\*\(\)\-\+,\.\?\/;:\'\"\[\]\{\}\|\\])(?=.{12,})`);
      const mediumRegex = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{8,})");
      
      //FIXME: use a better regex
      const passwordRegex = new RegExp(`^[a-zA-Z0-9,\.\?~!@#\$%\^&\*_]+$`);

      let error = null;
      this.formErrors.password = [];

      if (!passwordRegex.test(this.form.password)) {
        error = VALIDATION_ERRORS.PASSWORD_CHARACTERS;
        this.$set(this.formErrors.password, this.formErrors.password.length, error);
      }
      if (!(this.form.password.length >= 12 
      && this.form.password.length <= 24)) {
        error = VALIDATION_ERRORS.PASSWORD_LENGTH;
        this.$set(this.formErrors.password, this.formErrors.password.length, error);
      }

      if (this.form.password2 
      && this.form.password2 !== '') {
        this.confirmPassword();
      }
    },
    confirmPassword() {
      this.formErrors.password2 = [];
      if (this.form.password !== this.form.password2) {
        this.formErrors.password2.push(VALIDATION_ERRORS.PASSWORD_MISMATCH);
      }
    },
  }
}
</script>

<style scoped lang="scss">
  @import "../../stylesheets/mixins/alignment";
  $color-base: #0060ff;
  .content {
    width: 100%;
    height: auto;
    background: url("../../assets/images/bg.jpg") no-repeat center fixed;     // TODO image subject to copyright
    background-size: cover;
    position: relative;
  }
  .reset-wrapper {
    height: 100vh;
    width: 100%;
    position: relative;
  }

  .reset {
    background-color: #fff;
    padding: 2.0rem;
    -moz-box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2);
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2);

    @include absoluteCenter(380px);
  }
  .reset__introduction {
    color: darken(gray, 10%);
    font-size: 14px;
    text-align: center;
  }
  .btn--reset {
    color: #fff;
    background-color: $color-base;
    &:hover {
      background-color: lighten($color-base, 5%);
    }
  }

  .button-group {
    margin-top: 1.5rem;

    .form__link {
      color: $color-base;
      font-size: 0.85rem;
      margin-top: 0.5rem;
      display: block;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .form__input {
    font-size: 0.85rem;
  }
  .col-form-label {
    font-size: 14px;
  }

  @media only screen and (max-width: 468px) {
    .reset {
      width: 100%;
    }
  }
</style>
